import { useTranslation as e } from "../../i18n.mjs";
import { toolbarActionItem as t } from "../../components/content-controls/toolbar-action-item.mjs";
import { getShortcut as n, rawShortcuts as r } from "../../utils/get-shortcuts.mjs";
import { getListIcon as i, setList as a } from "./utils/list.mjs";
import { useEditorState as o } from "@tiptap/react";
import { useMemo as s } from "react";
import { jsx as c } from "react/jsx-runtime";
//#region src/extensions/list-extension/use-list-extension-toolbar.tsx
var l = (l, u) => {
	let { t: d } = e(), f = o({
		editor: l,
		selector: ({ editor: e }) => ({
			isEditable: e?.options.editable ?? !1,
			isActive: e?.isActive(u) ?? !1
		})
	}), p = !f?.isEditable, m = f?.isActive;
	return s(() => {
		let e = d(`${u}`), o = n(r.list[u]), s = i({ listType: u });
		return t({
			active: m,
			disabled: p,
			icon: /* @__PURE__ */ c(s, {}),
			label: e,
			onClick: () => a({
				editor: l,
				listType: u
			}),
			tooltip: `${e} (${o})`
		});
	}, [
		l,
		m,
		p,
		u,
		d
	]);
};
//#endregion
export { l as useListExtensionToolbar };
